export enum VARIABLES {
  inputHeight = '32px',
  inputBorderRadius = '3px',
  buttonHeight = '32px',
  buttonBorderRadius = '2px',

  sidebarWidth = '256px',

  zIndex1 = 1,
  zIndex2 = 2,
  zIndex3 = 3,
  zIndex4 = 4,
  zIndex5 = 5,
  zIndex6 = 6,
  zIndex7 = 7,
  zIndex8 = 8,
  zIndex9 = 9,
  zIndex10 = 10,

  mapButtonMargin = '12px',
  mapButtonSize = '40px',
  mapLayerButtonSize = '60px',
  mapButtonBorderRadius = '6px',

  searchSize = '300px',

  coordinateWindowPaddings = '15px 20px',
  coordinateWindowWidth = '300px',
  coordinateWindowHeight = '300px',
  coordinateWindowWidthToDecrease = '300px',
  coordinateWindowHeightToDecrease = '250px',
  coordinateWindowBorderRadius = '6px',

  imgCropControlHeight = '4px',
  imgCropControlHandle = '10px',
}
